
import { BookingFormData, ContactDetails } from "../ParcelBookingForm";
import { useMultiContactValidation } from "./hooks/useMultiContactValidation";
import { useProfileSync } from "./hooks/useProfileSync";

export const useMultiContactForm = (
  formData: BookingFormData,
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>,
  onValidationChange?: (isValid: boolean) => void
) => {
  // Use validation hook
  const { isContactsValid } = useMultiContactValidation(formData, onValidationChange);

  // Use profile sync hook
  useProfileSync(setFormData);

  const handleCollectionContactsChange = (contacts: ContactDetails[] | ((prev: ContactDetails[]) => ContactDetails[])) => {
    console.log(`📥 RECEIVED in handleCollectionContactsChange`);
    
    setFormData(prev => {
      const newContacts = typeof contacts === 'function' ? contacts(prev.collectionContacts) : contacts;
      console.log(`📊 UPDATING formData.collectionContacts:`, newContacts.map((c, i) => `[${i}]: ${c.name} (${c.email})`));
      
      return {
        ...prev,
        collectionContacts: newContacts
      };
    });
  };

  const handleDeliveryContactsChange = (contacts: ContactDetails[] | ((prev: ContactDetails[]) => ContactDetails[])) => {
    console.log(`📥 RECEIVED in handleDeliveryContactsChange`);
    
    setFormData(prev => {
      const newContacts = typeof contacts === 'function' ? contacts(prev.deliveryContacts) : contacts;
      console.log(`📊 UPDATING formData.deliveryContacts:`, newContacts.map((c, i) => `[${i}]: ${c.name} (${c.email})`));
      
      return {
        ...prev,
        deliveryContacts: newContacts
      };
    });
  };

  const handleSwapContacts = () => {
    setFormData(prev => ({
      ...prev,
      collectionContacts: prev.deliveryContacts,
      deliveryContacts: prev.collectionContacts
    }));
  };

  return {
    handleCollectionContactsChange,
    handleDeliveryContactsChange,
    handleSwapContacts,
    isContactsValid,
  };
};
